import { CALL_API } from './api'
import { getAllCookies, TOKEN } from 'Lib'

export default store => next => action => {

    const entry = action[CALL_API]
    // const ignorTypes  = [types.]
    if (typeof entry !== 'object') return next(action)

    let token = null
    const allCookies = getAllCookies()
    if (allCookies && allCookies[TOKEN]) {
        token = allCookies[TOKEN]
    }

    if (!token) return next(action)

    if (token) {
        entry.headers.Authorization = `Bearer ${token}`

    }
    entry.headers["Access-Control-Allow-Origin"] = "*"
    entry.headers["Access-Control-Allow-Methods"] = "*"
    entry.headers["Access-Control-Allow-Headers"] = "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With"
    next(action)
}



// WEBPACK FOOTER //
// ./src/middlewares/setToken.js